import { Box } from "@mui/system";
import { DataGrid, GridColDef, GridFilterModel, GridSortModel } from "@mui/x-data-grid";

import { LeadData } from "../../types/leads.types";


interface Props {
  rows: LeadData[];
  columns: GridColDef<LeadData>[];
  loading: boolean;
  pageSize: number;
  currentPage: number;
  onPageChange: (newPage: number) => void;
  onRowClick?: (rowData: LeadData) => void;
  onFilterModelChange?: (model: GridFilterModel) => void;
  onSortModelChange?: (model: GridSortModel) => void;
}

const LeadsDataGrid = ({ rows, columns, loading, onRowClick, onFilterModelChange, onSortModelChange }: Props) => {
  return (
    <Box sx={{
      width: "100%",
      overflowX: "auto",
      overflowY: "visible",
      borderRadius: "16px 16px 0 0",
      border: "1px solid #e0e0e0",
      position: "relative",
    }}>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight
        hideFooter
        disableRowSelectionOnClick
        disableVirtualization
        loading={loading}
        filterMode="server"
        sortingMode="server"
        onFilterModelChange={onFilterModelChange}
        onSortModelChange={onSortModelChange}
        onRowClick={(params) => {
          if (onRowClick) {
            onRowClick(params.row);
          }
        }}
        sx={{
          border: "1px solid #e0e0e0",
          minWidth: "max-content",
          "& .MuiDataGrid-main": {
            overflowX: "visible",
            overflowY: "visible",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "visible !important",
            overflowY: "visible !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#E77825",
            color: "#FFF",
            fontWeight: "800",
          },
          "& .MuiDataGrid-columnHeaderTitle":{
            fontWeight:700,
            fontSize:"16px"
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#f5f5f5",
            cursor: "pointer",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          }
        }}
      />
    </Box>
  )
}

export default LeadsDataGrid;